import { render, staticRenderFns } from "./ActivityImg.vue?vue&type=template&id=2337ccc0&scoped=true&"
import script from "./ActivityImg.vue?vue&type=script&lang=js&"
export * from "./ActivityImg.vue?vue&type=script&lang=js&"
import style0 from "./ActivityImg.vue?vue&type=style&index=0&id=2337ccc0&lang=scss&scoped=true&"
import style1 from "./ActivityImg.vue?vue&type=style&index=1&id=2337ccc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2337ccc0",
  null
  
)

export default component.exports